import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { CatalogService } from './catalog.service';
import { MetaData } from './model/metadata';
import { Cast } from './model/cast';
import { Crew } from './model/crew';
import { Award } from './model/award';

@Component({
    templateUrl: 'catalog-api.component.html'
})
export class CatalogApiComponent implements OnInit {
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    query = '';
    jsonstring: any;
    metadata: MetaData[];
    allTitles: MetaData[];
    filteredTitles: MetaData[];
    detailView = false;
    selectedTitle: MetaData;
    dataPage = 0;
    casts: Cast[];
    crews: Crew[];
    awards: Award[];
    viewSearchResult = false;
    countryType = 'Country';
    selectedParrotId: string;


    constructor(private _service: NotificationsService,
        private catalogService: CatalogService
    ) { }


    getCatalogues() {
        this.submitting = true;
        this.viewSearchResult = false;
        this.detailView = false;
        let searchInput: string;

        if (this.selectedParrotId !== undefined) {
            searchInput = this.selectedParrotId;
        } else {
            searchInput = this.query;
        }
        this.catalogService.getCatalog(searchInput)
            .then(res => {
                this.metadata = res.metadata;
                if (this.metadata === undefined) {
                    this.errorHandler(res.warning.message);
                } else {
                    this.viewSearchResult = true;
                }
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }

    getAllCatalogues() {
        this.catalogService.getAllCatalogue()
            .then(res => {
                this.allTitles = res.metadata;
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }
    clickViewType(event: any) {

    }
    ngOnInit() {
        this.getAllCatalogues();
    }


    filter(term: string) {
        this.selectedParrotId = undefined;
        this.query = term;
        if (term !== '') {
            this.filteredTitles = this.allTitles.filter(u => {
                if (u.title.toLowerCase().includes(term.toLowerCase())) {
                    return u;
                } else if (u.parrot_id.toLowerCase().includes(term.toLowerCase())) {
                    return u;
                } else if (u.display_name.toLowerCase().includes(term.toLowerCase())) {
                    return u;
                }
            });
        } else {
            this.filteredTitles = [];
        }
    }

    clickCatalog(catalog: MetaData) {
        this.query = catalog.display_name;
        this.selectedParrotId = catalog.parrot_id;
    }
    handleBlur() {
        setTimeout(() => {
            this.filteredTitles = [];
        }, 200);
    }
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                this._service.success(this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        this.notificationContent = error;
        this.createNotification();
    }
    viewDetail(data: MetaData, event: any) {
        event.stopPropagation();
        this.selectedTitle = data;
        this.detailView = true;
    }

    clickViewData() {
        this.dataPage = 1;
    }
    clickViewExpanded() {
        this.dataPage = 2;
    }
    clickViewMetaData() {
        this.dataPage = 0;
    }
    closeSearchResult() {
        this.detailView = false;
        this.viewSearchResult = false;
    }

    closeDetail() {
        this.detailView = false;
    }
}




// WEBPACK FOOTER //
// ./src/app/catalogue/catalog-api/catalog-api.component.ts